export const nameof = (name) => name;
